import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store, { persistor } from "./Store/Store";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { Loader, LoaderProvider } from "./Components/loader";
import { Flip, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./utils/locale/locale.config";
import { RoutersProvider } from "./Router/routerContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    {/* <React.StrictMode> */}
    <LoaderProvider>
      <Loader />
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <RoutersProvider>
            <App />
            <ToastContainer
              position="top-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              // theme="colored"
              transition={Flip}
            />
          </RoutersProvider>
        </PersistGate>
      </Provider>
    </LoaderProvider>
    {/* </React.StrictMode> */}
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
